import { DefaultRequest } from 'scripts/api';

/* Model */
class KronosConfigurationModel extends App.Models.BaseModel {
    modelUrl = 'ukg/KronosConfiguration';
}

App.Models.KronosConfiguration = KronosConfigurationModel;

/* Collection */
class KronosConfigurationCollection extends App.Collections.BaseCollection {
    url = 'ukg/KronosConfiguration';
    model = App.Models.KronosConfiguration;
}

App.Collections.KronosConfigurations = KronosConfigurationCollection;

/* Router */
class KronosConfigurationRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'KronosConfiguration';
        const model = App.Models.KronosConfiguration;
        const collectionClass = App.Collections.KronosConfigurations;

        super(entityName, model, collectionClass);

        this.useStringID = true;
    }

    batchDelete = (idsToDelete) => {
        if (idsToDelete && idsToDelete.length > 0) {
          App.Forms[this.entityName].pagination.first = 0;
          const grid = App.Forms[this.entityName].table;
          const ajax = new Monet.Ajax();
          ajax.url = `ukg/${this.entityName}/BatchDelete`;
          ajax.method = "post";
          ajax.data = idsToDelete;

          grid.setSelectedRows([]);
          
          ajax.success = () => {
            this.updateGrid(this.getFilter(), Monet.Grid.addDataToGrid);
        };

        ajax.error = (xhr) => {
            if (xhr.responseText !== "") {
                var response = JSON.parse(xhr.responseText);
                this.showErrorExceptionOnPopupForm(response);
            }
        };

        ajax.send();
    }
};
      
    messageRequired = (errorMessages, value, name, label) => {
        var field = App.Forms.KronosConfiguration.form.fields[name];
        field.rootEl.className = field.rootEl.className.replace('control-group error', '');
        if (value == null) {
            var msg = Monet.I18n.getResourcesByKey(label) + ' ' + Monet.I18n.getResourcesByKey('error.isrequired');
            errorMessages.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(msg));
            field.rootEl.className += ' control-group error';
            return true;
        }
        return false;
    }

validateFieldsForTest = (values) => {
    var monetAlert    = document.querySelector("#KronosConfiguration div.monetInlineAlerContainer"),
        monetMessage  = new Monet.Form.Messages.InlineMessage(),
        errorMessages = { "errorMessages": [] };
    monetAlert.innerHTML = "";

    if (!this.messageRequired(errorMessages, values.host, 'host', 'kronosConfiguration.host')) {
        App.Forms.KronosConfiguration.form.fields.host.rootEl.className.replace('control-group error', '');
        if (!/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www\.)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(values.host)) {
            errorMessages.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('kronosConfiguration.hostInvalid'));
            App.Forms.KronosConfiguration.form.fields.host.rootEl.className += ' control-group error';
        }
    }
    this.messageRequired(errorMessages, values.login, 'login', 'kronosConfiguration.login');
    this.messageRequired(errorMessages, values.password, 'password', 'kronosConfiguration.password');
    this.messageRequired(errorMessages, values.field, 'field', 'kronosConfiguration.field');
    this.messageRequired(errorMessages, values.clientId, 'clientId', 'kronosConfiguration.clientId');
    this.messageRequired(errorMessages, values.clientSecret, 'clientSecret', 'kronosConfiguration.clientSecret');

    if (errorMessages.errorMessages.length > 0) {
        monetMessage.setScope("#KronosConfiguration");
        monetMessage.setInfoType("error");
        monetMessage.setMessage(errorMessages);
        monetMessage.triggerMessage();
        return {
            status: false,
            errorMessages: errorMessages.errorMessages
        };
    } else {
        return false;
    }
}

    onValidate = () => {
        var values = App.Forms.KronosConfiguration.form.getValues();
        var allow = this.validateFieldsForTest(values);
        if (allow) {
            this.allow_submit = allow;
        }
    }

    //This function is executed by a meta of field
    testServer = () => {
        var values = App.Forms.KronosConfiguration.form.getValues();
        if (!this.validateFieldsForTest(values)) {
            const request = new DefaultRequest({
                method: "POST",
                url: "ukg/KronosConfiguration/Ping",
                data: {
                    host: values.host,
                    login: values.login,
                    password: values.password,
                    clientId: values.clientId,
                    clientSecret: values.clientSecret
                },
                success: function (data) {
                    if (data === "SUCCESS") {
                        new Greenmile.Components.AlertModal("kronosConfiguration.successConection")
                            .show();
                    } else {
                        new Greenmile.Components.AlertModal("kronosConfiguration.errorConection")
                            .show();
                    }
                },
                error: function () {
                    new Greenmile.Components.AlertModal("kronosConfiguration.errorConection")
                        .show();
                }
            });
            request.send();
        }
    }
    
    createClientSecretField = (sectionColumn) => {
        const clientSecretDiv = document.createElement("div");
        clientSecretDiv.className = "textField";
        clientSecretDiv.id = "KronosConfiguration_clientSecret";
        clientSecretDiv.setAttribute("sectionorder", "3");
    
        const clientSecretField = document.createElement("input");
        clientSecretField.type = "text";
        clientSecretField.name = "clientSecret";
        clientSecretField.id = "clientSecret";
        clientSecretField.className = "form-control";
    
        const clientSecretLabel = document.createElement("label");
        clientSecretLabel.htmlFor = "clientSecret";
        clientSecretLabel.innerHTML = Monet.I18n.getResourcesByKey("kronosConfiguration.clientSecret");
    
        clientSecretDiv.appendChild(clientSecretLabel);
        clientSecretDiv.appendChild(clientSecretField);
        sectionColumn.appendChild(clientSecretDiv);
    
        App.Forms.KronosConfiguration.form.fields.clientSecret = {
            rootEl: clientSecretDiv,
            inputEl: clientSecretField,
            getValue: () => clientSecretField.value,
            setValue: (value) => { clientSecretField.value = value; }, 
            validate: () => {
                const value = clientSecretField.value;
                if (!value) {
                    return Monet.I18n.getResourcesByKey("kronosConfiguration.clientSecretRequired");
                }
                return null;
            }
        };
    };
    
    createClientIdField = (sectionColumn) => {
        const clientIdDiv = document.createElement("div");
        clientIdDiv.className = "textField";
        clientIdDiv.id = "KronosConfiguration_clientId";
        clientIdDiv.setAttribute("sectionorder", "4");
    
        const clientIdField = document.createElement("input");
        clientIdField.type = "text";
        clientIdField.name = "clientId";
        clientIdField.id = "clientId";
        clientIdField.className = "form-control";
    
        const clientIdLabel = document.createElement("label");
        clientIdLabel.htmlFor = "clientId";
        clientIdLabel.innerHTML = Monet.I18n.getResourcesByKey("kronosConfiguration.clientId");
    
        clientIdDiv.appendChild(clientIdLabel);
        clientIdDiv.appendChild(clientIdField);
        sectionColumn.appendChild(clientIdDiv);
    
        App.Forms.KronosConfiguration.form.fields.clientId = {
            rootEl: clientIdDiv,
            inputEl: clientIdField,
            getValue: () => clientIdField.value,
            setValue: (value) => { clientIdField.value = value; },
            validate: () => {
                const value = clientIdField.value;
                if (!value) {
                    return Monet.I18n.getResourcesByKey("kronosConfiguration.clientIdRequired");
                }
                return null;
            }
        };
    };
    
    afterCreateForm = (entity, formData, crudStage) => {
        const sectionColumn2 = document.querySelector(".KronosConfiguration .MonetUIFormSectionColumn[sectioncolumn='2']");
        if (sectionColumn2) {
            const label = document.createElement("label");
            label.className = "kronosConfigurationHOSEventsLabel";
            label.innerHTML = Monet.I18n.getResourcesByKey("applyable.hos.events");
            sectionColumn2.insertBefore(label, sectionColumn2.childNodes[0]);
        }
    
        const sectionColumn1 = document.querySelector(".KronosConfiguration .MonetUIFormSectionColumn[sectioncolumn='1']");
        if (sectionColumn1) {
				const clientSecretExists = sectionColumn1.querySelector("#KronosConfiguration_clientSecret");
				const clientIdExists = sectionColumn1.querySelector("#KronosConfiguration_clientId");
 
				if (!clientSecretExists && !clientIdExists) {
					this.createClientSecretField(sectionColumn1);
					this.createClientIdField(sectionColumn1);
			  }
        }
    };
}

App.Routers.KronosConfiguration = KronosConfigurationRouter;

